<template>
    <div>
      <v-dialog v-model="dialog.dialogProgress" persistent width="300" eager>
        <v-card color="primary" dark>
          <v-card-text>
            {{progressMessage}}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-data-table
        v-model="vDataTable.selected"
        :headers="headers"
        :items="vDataTable.data"
        :search="vDataTable.search"
        show-select
        fixed-header
        :expanded.sync="vDataTable.expanded"
        show-expand
        :page.sync="vDataTable.options.page"
        :itemsPerPage.sync="vDataTable.options.itemsPerPage"
        :options.sync="vDataTable.options"
        :height="$vuetify.breakpoint.height - 123 - offsetAppBar"
        :footer-props="{
          itemsPerPageText: $t('itemsPerPageText'),
          itemsPerPageAllText: $t('itemsPerPageAllText'),
          showFirstLastPage: true,
          showCurrentPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
        item-key="category_skey"
        class="fill-height">
        <template v-slot:header.data-table-select="{ on, props }">
          <tr>
            <td>
              <v-simple-checkbox :ripple="false" v-bind="props" v-on="on"></v-simple-checkbox>
            </td>
            <td v-if="vDataTable.selected.length > 0">
              {{vDataTable.selected.length}}
            </td>
          </tr>
        </template>
        <template v-slot:top>
          <v-toolbar flat>
          <v-toolbar-title>LIS Category</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog.dialogAddEdit" max-width="500px" eager>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize">
                  <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined hide-details label="Category ID" v-model="vDataTable.editedItem.category_id"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field outlined hide-details label="Description" v-model="vDataTable.editedItem.category_desc"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                          <v-textarea
                            outlined hide-details
                            color="black"
                            label="Remark"
                            v-model="vDataTable.editedItem.remark"
                          ></v-textarea>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Over Limit TAT" v-model="vDataTable.editedItem.over_limit_tat" type="number" outlined dense hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Achieve %" v-model="vDataTable.editedItem.achieve_pct" type="number" outlined dense hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Std TAT" v-model="vDataTable.editedItem.std_tat" type="number" outlined dense hide-details></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Seq" v-model="vDataTable.editedItem.seq" type="number" outlined dense hide-details></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn outlined color="primary" @click="close">{{$t('cancel')}}</v-btn>
                    <v-btn outlined color="primary" @click="save">{{$t('save')}}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-divider class="mx-1" inset vertical></v-divider>
            <v-btn outlined color="primary" @click="checkDeleteselected" style="text-transform: capitalize">
              <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
            </v-btn>
            <v-divider class="mx-1" inset vertical></v-divider>
            <v-btn outlined color="primary" style="text-transform: capitalize" @click="retrieveCategory()">
              <img src="../assets/SoftwareClinicIcon/Find.png" height="30" weight="30"/>{{$t('find')}}
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field v-model="vDataTable.search" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
          </v-toolbar>
        </template>
        <!-- eslint-disable-next-line -->
        <template v-slot:item.data-table-select="{ isSelected, select }">
          <v-simple-checkbox :value="isSelected" :ripple="false" @input="select($event)" ></v-simple-checkbox>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="teal" small class="mr-2" v-bind="attrs" v-on="on" @click="editItem(item)">edit</v-icon>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="pink" small class="mr-2" v-bind="attrs" v-on="on" @click="deleteItemConfirm(item)">delete</v-icon>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <template v-slot:item.data-table-no="{ item, index }">
          {{((vDataTable.options.page - 1) * vDataTable.options.itemsPerPage) + index + 1}}
        </template>
        <template v-slot:no-data>
          <v-alert type="info">
            {{$t('noData')}}
          </v-alert>
        </template>
        <template v-slot:no-results>
          <v-alert type="warning">
            {{stringFormat($t('searchNotFound'),vDataTable.search)}}
          </v-alert>
        </template>
        <template v-slot:footer>
          <tr class="sticky-table-footer" style="position: absolute">
            <td>Selected({{vDataTable.selected.length}})s</td> 
          </tr>
        </template>
      <template v-slot:expanded-item="{ headers, item }"> 
        <td :colspan="headers.length">
          <v-card class="elevation-10">
            <v-card-text>
              <v-tabs color="primary" slider-color="secondary">
                <v-tab style="text-transform: capitalize">Sub Category</v-tab>
                <v-tab-item>
          <v-data-table v-model="item.selectedSubCategory" 
                                  :headers="subHeadersSubCategory"
                                  :items="item.lis_sub_category"
                                  :search="item.searchSubCategory"
                                  show-select
                                  :footer-props="{
                                    itemsPerPageText: $t('itemsPerPageText'),
                                    itemsPerPageAllText: $t('itemsPerPageAllText'),
                                    showFirstLastPage: true,
                                    showCurrentPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus',
                                  }"
                                  item-key="sub_category_skey"
                                  class="elevation-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Sub Category</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog.dialogAddEditSubCategory" max-width="500px" eager>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newSubCustomerIssueType(item)">
                              <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                            </v-btn>        
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">{{ formSubCategoryTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Sub Category ID" v-model="vDataTable.editedSubCategoryItem.sub_category_id"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Description" v-model="vDataTable.editedSubCategoryItem.sub_category_desc"></v-text-field>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                      <v-textarea
                                        outlined hide-details
                                        color="black"
                                        label="Remark"
                                        v-model="vDataTable.editedSubCategoryItem.remark"
                                      ></v-textarea>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                                <v-btn outlined color="primary" @click="closeSubCategory">{{$t('cancel')}}</v-btn>
                                <v-btn outlined color="primary" @click="saveSubCategory">{{$t('save')}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-btn outlined color="primary" @click="checkDeleteselectedSubCategory(item)" style="text-transform: capitalize">
                          <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
                        </v-btn>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="item.searchLanguage" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon color="teal" small class="mr-2" @click="editSubCategoryItem(item)">edit</v-icon>
                      <v-icon color="pink" small class="mr-2" @click="deleteSubCategoryConfirm(item)">delete</v-icon>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab style="text-transform: capitalize">Specimen Sticker</v-tab>
                <v-tab-item>
                  <v-data-table v-model="item.selectedCategorySpecimenSticker" 
                                  :headers="subHeadersCategorySpecimenSticker"
                                  :items="item.lis_category_specimen_sticker"
                                  :search="item.searchCategorySpecimenSticker"
                                  show-select
                                  :footer-props="{
                                    itemsPerPageText: $t('itemsPerPageText'),
                                    itemsPerPageAllText: $t('itemsPerPageAllText'),
                                    showFirstLastPage: true,
                                    showCurrentPage: true,
                                    firstIcon: 'mdi-arrow-collapse-left',
                                    lastIcon: 'mdi-arrow-collapse-right',
                                    prevIcon: 'mdi-minus',
                                    nextIcon: 'mdi-plus',
                                  }"
                                  item-key="sticker_cd"
                                  class="elevation-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>Sub Category</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog.dialogAddEditCategorySpecimenSticker" max-width="500px" eager>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn outlined color="primary" v-bind="attrs" v-on="on" style="text-transform: capitalize" @click="newCategorySpecimenSticker(item)">
                              <img src="../assets/SoftwareClinicIcon/New.png" height="30" weight="30"/>New
                            </v-btn>        
                          </template>
                          <v-card>
                            <v-card-title>
                              <span class="headline">{{ formCategorySpecimenStickerTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-select :items="dropDownData.lis_specimen_sticker" v-model="vDataTable.editedCategorySpecimenStickerItem.sticker_cd" item-text="sticker_desc" item-value="sticker_cd" label="Sticker" 
                                              persistent-hint outlined dense hide-details 
                                              :readonly="categorySpecimenStickerEdit">
                                    </v-select>
                                  </v-col>
                                  <v-col cols="12" sm="12" md="12">
                                    <v-text-field label="Print Qty" v-model="vDataTable.editedCategorySpecimenStickerItem.print_qty" type="number" outlined dense hide-details></v-text-field>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-card-text>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                                <v-btn outlined color="primary" @click="closeCategorySpecimenSticker">{{$t('cancel')}}</v-btn>
                                <v-btn outlined color="primary" @click="saveCategorySpecimenSticker">{{$t('save')}}</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-btn outlined color="primary" @click="checkDeleteselectedCategorySpecimenSticker(item)" style="text-transform: capitalize">
                          <img src="../assets/SoftwareClinicIcon/Delete.png" height="30" weight="30"/>Delete
                        </v-btn>
                        <v-divider class="mx-1" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="item.searchLanguage" append-icon="mdi-magnify" :label="$t('search')"></v-text-field>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-icon color="teal" small class="mr-2" @click="editCategorySpecimenStickerItem(item)">edit</v-icon>
                      <v-icon color="pink" small class="mr-2" @click="deleteCategorySpecimenStickerConfirm(item)">delete</v-icon>
                    </template>
                    <template v-slot:item.sticker_cd="{ item }">
                      <v-select :items="dropDownData.lis_specimen_sticker" v-model="item.sticker_cd" item-text="sticker_desc" item-value="sticker_cd" label="Sticker" readonly persistent-hint outlined dense hide-details>
                      </v-select>
                    </template>
                  </v-data-table>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </td>
      </template>
      </v-data-table> 
    </div>
  </template>
  <script>
  import { mapMutations, mapGetters, mapState } from 'vuex'
  export default {
    components: {
    },
  
    props: ['parentComponent'],
  
    data () {
      return {
        utils: require('@/utils'),
        stringFormat: require('string-format'),
        appName: process.env.VUE_APP_DB_APP_NAME,
        dialog: {
          dialogProgress: false,
          dialogAddEdit: false,
          dialogAddEditSubCategory: false,
          dialogAddEditCategorySpecimenSticker: false,
        },
        vDataTable: {
          search: '',
          selected: [],
          data: [],
          editedIndex: -1,
          editedItem: {
            win_name: '',
            window_comment: ''
          },
          defaultItem: {
            win_name: '',
            window_comment: ''
          },
          editedSubCategoryIndex: -1,
          editedSubCategoryItem: {
          },
          defaultSubCategoryItem: {
          },
          editedCategorySpecimenStickerIndex: -1,
          editedCategorySpecimenStickerItem: {
          },
          defaultCategorySpecimenStickerItem: {
          },
          options: {
            page: 1,
            itemsPerPage: -1,
            sortBy: [],
            sortDesc: [],
            groupBy: [],
            groupDesc: true,
            multiSort: true,
            // mustSort: true
          },
          expanded: [],
        },
        dropDownData: [],
        progressMessage: '',
        appSkey: -1,
        subCustomerIssueTypeEdit: true,
        categorySpecimenStickerEdit: true,
      }
    },
  
    computed: {
      ...mapGetters(['getShowAppBar', 'getAppBarHeight']),
      codeReadOnly () {
        return !(this.vDataTable.editedIndex === -1)
      },
      formTitle () {
        return this.vDataTable.editedIndex === -1 ? 'New Category' : 'Edit Category'
      },
      formSubCategoryTitle () {
        return this.vDataTable.editedSubCategoryIndex === -1 ? 'New Sub Category' : 'Edit Sub Category'
      },
      formCategorySpecimenStickerTitle () {
        return this.vDataTable.editedCategorySpecimenStickerIndex === -1 ? 'New Sticker' : 'Edit Sticker'
      },
      headers () {
        return [
          { text: '#', align: 'center', value: 'data-table-no' },
          { text: '', align: 'center', value: 'data-table-select' },
          { text: this.$t('actions'), value: 'actions', sortable: false },
          { text: 'category_id', align: 'left', value: 'category_id' },
          { text: 'category_desc', align: 'left', value: 'category_desc' },
          { text: 'remark', align: 'left', value: 'remark' },
          { text: 'over_limit_tat', align: 'left', value: 'over_limit_tat' },
          { text: 'achieve_pct', align: 'left', value: 'achieve_pct' },
          { text: 'std_tat', align: 'left', value: 'std_tat' },
          { text: 'seq', align: 'left', value: 'seq' },
        ]
      },
      subHeadersSubCategory () {
        return [
          { text: '', align: 'center', value: 'data-table-select' },
          { text: this.$t('actions'), value: 'actions', sortable: false },
          { text: 'sub_category_id', value: 'sub_category_id' },
          { text: 'sub_category_desc', value: 'sub_category_desc' },
          { text: 'remark', value: 'remark', align: 'right' },
        ]
      },
      subHeadersCategorySpecimenSticker () {
        return [
          { text: '', align: 'center', value: 'data-table-select' },
          { text: this.$t('actions'), value: 'actions', sortable: false },
          { text: 'sticker_cd', width: '200', value: 'sticker_cd' },
          { text: 'print_qty', value: 'print_qty' },
        ]
      },
      offsetAppBar () {
        return this.getShowAppBar ? this.getAppBarHeight : 0
      }
    },
  
    watch: {
      'dialog.dialogAddEdit' (val) {
        val || this.close()
      }
    },
  
    async created () {
      this.retrieveDropDown()
      await this.retrieveCategory()
    },
  
    mounted () {
    },
  
    updated () {
    },
  
    methods: {
      selectLanguage (language) {
      },
      initialize () {
        this.vDataTable.selected = []
        this.vDataTable.editedIndex = -1
        this.vDataTable.editedItem = {
          win_name: '',
          window_comment: ''
        }
        this.vDataTable.defaultItem = {
          win_name: '',
          window_comment: ''
        }
      },
      newSubCustomerIssueType (item) {
        this.vDataTable.editedItem = Object.assign({}, item)
        // this.dialogLanguage = true
        this.subCustomerIssueTypeEdit = false
      },
      newCategorySpecimenSticker (item) {
        this.vDataTable.editedItem = Object.assign({}, item)
        // this.dialogLanguage = true
        this.categorySpecimenStickerEdit = false
      },
      retrieveDropDown () {
        this.axios.post(process.env.VUE_APP_API + '/lis_category/retrieveDropDown' + process.env.VUE_APP_DATABASE_TYPE, {
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.dropDownData = response.data.data[0]
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      findSubCategory (categorySkey) {
        return this.vDataTable.data.find(function (x) {
          return (x.category_skey === categorySkey)
        }).lis_sub_category
      },
      findSelectedSubCategory (categorySkey) {
        return this.vDataTable.data.find(function (x) {
          return (x.category_skey === categorySkey)
        }).selectedSubCategory
      },
      findCategorySpecimenSticker (categorySkey) {
        return this.vDataTable.data.find(function (x) {
          return (x.category_skey === categorySkey)
        }).lis_category_specimen_sticker
      },
      findSelectedCategorySpecimenSticker (categorySkey) {
        return this.vDataTable.data.find(function (x) {
          return (x.category_skey === categorySkey)
        }).selectedCategorySpecimenSticker
      },
      async retrieveCategory () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/retrieveCategory' + process.env.VUE_APP_DATABASE_TYPE, {
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.data = response.data.data
              this.initialize()
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async addCategory (category) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/addCategory' + process.env.VUE_APP_DATABASE_TYPE, {
          category: category
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.editedItem.category_skey = response.data.data.category_skey
              this.vDataTable.data.push(this.vDataTable.editedItem)
              this.close()
              this.$swal({type: 'success', title: response.data.reasonText})
              this.retrieveCategory()
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async updateCategory (category) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/updateCategory' + process.env.VUE_APP_DATABASE_TYPE, {
          category: category
        })
          .then(response => {
            if (response.data.isSuccess) {
              Object.assign(this.vDataTable.data[this.vDataTable.editedIndex], this.vDataTable.editedItem)
              this.close()
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      async addSubCategory (categorySkey, subCategory) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/addSubCategory' + process.env.VUE_APP_DATABASE_TYPE, {
          category_skey: categorySkey,
          sub_category: subCategory
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.vDataTable.editedSubCategoryItem.sub_category_skey = response.data.data.sub_category_skey
              this.findSubCategory(categorySkey).push(this.vDataTable.editedSubCategoryItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      async updateSubCategory (subCategory) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/updateSubCategory' + process.env.VUE_APP_DATABASE_TYPE, {
          sub_category: subCategory
        })
          .then(response => {
            if (response.data.isSuccess) {
              Object.assign(this.findSubCategory(subCategory.category_skey)[this.vDataTable.editedSubCategoryIndex], this.vDataTable.editedSubCategoryItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      async addCategorySpecimenSticker (categorySkey, categorySpecimenSticker) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/addCategorySpecimenSticker' + process.env.VUE_APP_DATABASE_TYPE, {
          category_skey: categorySkey,
          category_specimen_sticker: categorySpecimenSticker
        })
          .then(response => {
            if (response.data.isSuccess) {
              this.findCategorySpecimenSticker(categorySkey).push(this.vDataTable.editedCategorySpecimenStickerItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      async updateCategorySpecimenSticker (categorySpecimenSticker) {
        await this.axios.post(process.env.VUE_APP_API + '/lis_category/updateCategorySpecimenSticker' + process.env.VUE_APP_DATABASE_TYPE, {
          category_specimen_sticker: categorySpecimenSticker
        })
          .then(response => {
            if (response.data.isSuccess) {
              Object.assign(this.findCategorySpecimenSticker(categorySpecimenSticker.category_skey)[this.vDataTable.editedCategorySpecimenStickerIndex], this.vDataTable.editedCategorySpecimenStickerItem)
              this.$swal({type: 'success', title: response.data.reasonText})
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            this.$swal({type: 'error', title: e.message})
          })
      },
      checkDeleteselected () {
        if (this.vDataTable.selected.length > 0) {
          this.$swal({
            text: 'Are you sure you want to delete selected Category?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.deleteSelected()
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'Please select Category to delete'})
        }
      },
      checkDeleteselectedSubCategory (item) {
        if (this.findSelectedSubCategory(item.category_skey).length > 0) {
          this.$swal({
            text: 'Are you sure you want to delete selected Sub Category?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.deleteSubCategorySelected(item)
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'Please select Sub Category to delete'})
        }
      },
      checkDeleteselectedCategorySpecimenSticker (item) {
        if (this.findSelectedCategorySpecimenSticker(item.category_skey).length > 0) {
          this.$swal({
            text: 'Are you sure you want to delete selected Specimen Sticker?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes'),
            cancelButtonText: this.$t('no')
          }).then((result) => {
            if (result) {
              this.deleteCategorySpecimenStickerSelected(item)
            }
          })
        } else {
          this.$swal({type: 'warning', title: 'Please select Specimen Sticker to delete'})
        }
      },
      async deleteSelected () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
  
        var del = []
  
        await this.utils.asyncForEach(this.vDataTable.selected, async function (x) {
          this.progressMessage = this.stringFormat('Deleting Customer Issue Type {}', x.code)
          var val = await this.deleteCategory(x)
  
          if (val !== undefined) {
            del.push(val)
          }
        }.bind(this))
  
        // del.forEach(x => {
        //   this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
        // })
  
        for (const x in del) {
          this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(x), 1)
        }
  
        this.dialog.dialogProgress = false
        // this.retrieveWindow(this.appName)
      },
      async deleteSubCategorySelected (item) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')

        var del = []

        await this.utils.asyncForEach(this.findSelectedSubCategory(item.category_skey), async function (x) {
          this.progressMessage = this.stringFormat('Deleting Sub Customer Issue Type', x.sub_customer_issue_type_cd)
          var val = await this.deleteSubCategory(x)

          if (val !== undefined) {
            del.push(val)
          }
        }.bind(this))
        for (const x in del) {
          var selectedSubCategory = this.findSelectedSubCategory(item.category_skey)
          selectedSubCategory.splice(selectedSubCategory.indexOf(x), 1)
        }

        this.dialog.dialogProgress = false
      },
      async deleteCategorySpecimenStickerSelected (item) {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')

        var del = []

        await this.utils.asyncForEach(this.findSelectedCategorySpecimenSticker(item.category_skey), async function (x) {
          this.progressMessage = this.stringFormat('Deleting Sub Customer Issue Type', x.sub_customer_issue_type_cd)
          var val = await this.deleteCategorySpecimenSticker(x)

          if (val !== undefined) {
            del.push(val)
          }
        }.bind(this))
        for (const x in del) {
          var selectedCategorySpecimenSticker = this.findSelectedCategorySpecimenSticker(item.category_skey)
          selectedCategorySpecimenSticker.splice(selectedCategorySpecimenSticker.indexOf(x), 1)
        }

        this.dialog.dialogProgress = false
      },
      async deleteCustomerIssueType (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var code = item.code
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/deleteCustomerIssueType' + process.env.VUE_APP_DATABASE_TYPE, {
            code: code
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.vDataTable.data.indexOf(item) >= 0) {
                  this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      async deleteCategory (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var categorySkey = item.category_skey
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/lis_category/deleteCategory' + process.env.VUE_APP_DATABASE_TYPE, {
            category_skey: categorySkey
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.vDataTable.data.indexOf(item) >= 0) {
                  this.vDataTable.data.splice(this.vDataTable.data.indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      editItem (item) {
        this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
        this.vDataTable.editedItem = Object.assign({}, item)
        this.dialog.dialogAddEdit = true
      },
      editSubCategoryItem (item) {
        this.subCustomerIssueTypeEdit = true
        this.vDataTable.editedSubCategoryIndex = this.findSubCategory(item.category_skey).indexOf(item)
        this.vDataTable.editedSubCategoryItem = Object.assign({}, item)
        this.dialog.dialogAddEditSubCategory = true
      },
      editCategorySpecimenStickerItem (item) {
        this.categorySpecimenStickerEdit = true
        this.vDataTable.editedCategorySpecimenStickerIndex = this.findCategorySpecimenSticker(item.category_skey).indexOf(item)
        this.vDataTable.editedCategorySpecimenStickerItem = Object.assign({}, item)
        this.dialog.dialogAddEditCategorySpecimenSticker = true
      },
      async deleteItemConfirm (item) {
        // this.vDataTable.editedIndex = this.vDataTable.data.indexOf(item)
        // this.vDataTable.editedItem = Object.assign({}, item)
        this.$swal({
          text: this.stringFormat('Are you sure want to delete Category {0}?', item.category_desc),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            var val = await this.deleteCategory(item)
            if (val !== undefined) {
              if (this.vDataTable.selected.indexOf(item) >= 0) {
                this.vDataTable.selected.splice(this.vDataTable.selected.indexOf(item), 1)
              }
            }
          }
        })
      },
      async deleteSubCategory (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var SubCategorySkey = item.sub_category_skey
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/lis_category/deleteSubCategory' + process.env.VUE_APP_DATABASE_TYPE, {
            sub_category_skey: SubCategorySkey
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.findSubCategory(item.category_skey).indexOf(item) >= 0) {
                  this.findSubCategory(item.category_skey).splice(this.findSubCategory(item.category_skey).indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      async deleteSubCategoryConfirm (item) {
        this.vDataTable.editedSubCategoryIndex = this.findSubCategory(item.category_skey).indexOf(item)
        this.vDataTable.editedSubCategoryItem = Object.assign({}, item)
        this.$swal({
          text: this.stringFormat('Are you sure delete Sub Category {}?', item.sub_category_id),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            var val = await this.deleteSubCategory(item)
            if (val !== undefined) {
              var selectedSubCategory = this.findSelectedSubCategory(item.category_skey)
              if (selectedSubCategory.indexOf(item) >= 0) {
                selectedSubCategory.splice(selectedSubCategory.indexOf(item), 1)
              }
            }
            this.vDataTable.editedSubCategoryItem = Object.assign({}, this.vDataTable.defaultSubCategoryItem)
            this.vDataTable.editedSubCategoryIndex = -1
          }
        })
      },
      async deleteCategorySpecimenSticker (item) {
        try {
          this.dialog.dialogProgress = true
          this.progressMessage = this.$t('waiting')
          var categorySkey = item.category_skey
          var stickerCode = item.sticker_cd
          var valRet
          await this.axios.post(process.env.VUE_APP_API + '/lis_category/deleteCategorySpecimenSticker' + process.env.VUE_APP_DATABASE_TYPE, {
            category_skey: categorySkey,
            sticker_cd: stickerCode
          })
            .then(async response => {
              if (response.data.isSuccess) {
                if (this.findCategorySpecimenSticker(item.category_skey).indexOf(item) >= 0) {
                  this.findCategorySpecimenSticker(item.category_skey).splice(this.findCategorySpecimenSticker(item.category_skey).indexOf(item), 1)
                }
                this.$swal({type: 'success', title: response.data.reasonText})
                valRet = item
              } else {
                await this.$swal({type: 'error', title: response.data.reasonText})
              }
            })
            .catch(async e => {
              await this.$swal({type: 'error', title: e.message})
            })
          return valRet
        } catch (e) {
          await this.$swal({type: 'error', title: e.message})
        } finally {
          this.dialog.dialogProgress = false
        }
      },
      async deleteCategorySpecimenStickerConfirm (item) {
        this.vDataTable.editedCategorySpecimenStickerIndex = this.findCategorySpecimenSticker(item.category_skey).indexOf(item)
        this.vDataTable.editedCategorySpecimenStickerItem = Object.assign({}, item)
        this.$swal({
          text: this.stringFormat('Are you sure delete Specimen Sticker {}?', item.sticker_cd),
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('no')
        }).then(async (result) => {
          if (result) {
            var val = await this.deleteCategorySpecimenSticker(item)
            if (val !== undefined) {
              var selectedCategorySpecimenSticker = this.findSelectedCategorySpecimenSticker(item.category_skey)
              if (selectedCategorySpecimenSticker.indexOf(item) >= 0) {
                selectedCategorySpecimenSticker.splice(selectedCategorySpecimenSticker.indexOf(item), 1)
              }
            }
            this.vDataTable.editedCategorySpecimenStickerItem = Object.assign({}, this.vDataTable.defaultCategorySpecimenStickerItem)
            this.vDataTable.editedCategorySpecimenStickerIndex = -1
          }
        })
      },
      close () {
        this.dialog.dialogAddEdit = false
        this.$nextTick(() => {
          this.vDataTable.editedItem = Object.assign({}, this.vDataTable.defaultItem)
          this.vDataTable.editedIndex = -1
        })
      },
      async save () {
        if (this.vDataTable.editedIndex > -1) {
          await this.updateCategory(this.vDataTable.editedItem)
        } else {
          await this.addCategory(this.vDataTable.editedItem)
        }
      },
      closeSubCategory () {
        this.dialog.dialogAddEditSubCategory = false
        this.$nextTick(() => {
          this.vDataTable.editedSubCategoryItem = Object.assign({}, this.vDataTable.defaultSubCategoryItem)
          this.vDataTable.editedSubCategoryIndex = -1
        })
      },
      async saveSubCategory () {
        if (this.vDataTable.editedSubCategoryIndex > -1) {
          await this.updateSubCategory(this.vDataTable.editedSubCategoryItem)
        } else {
          await this.addSubCategory(this.vDataTable.editedItem.category_skey, this.vDataTable.editedSubCategoryItem)
        }
        this.closeSubCategory()
      },
      closeCategorySpecimenSticker () {
        this.dialog.dialogAddEditCategorySpecimenSticker = false
        this.$nextTick(() => {
          this.vDataTable.editedCategorySpecimenStickerItem = Object.assign({}, this.vDataTable.defaultCategorySpecimenStickerItem)
          this.vDataTable.editedCategorySpecimenStickerIndex = -1
        })
      },
      async saveCategorySpecimenSticker () {
        if (this.vDataTable.editedCategorySpecimenStickerIndex > -1) {
          await this.updateCategorySpecimenSticker(this.vDataTable.editedCategorySpecimenStickerItem)
        } else {
          await this.addCategorySpecimenSticker(this.vDataTable.editedItem.category_skey, this.vDataTable.editedCategorySpecimenStickerItem)
        }
        this.closeCategorySpecimenSticker()
      }
    },
  }
  </script>
  <style scoped>
  .sticky-table-footer td {
    font-weight: bold;
    position: sticky;
    bottom: 0;
    background-color: #f8f8f8;
    border-top: thin solid rgba(0,0,0,.12);
  }
  </style>